import { render, staticRenderFns } from "./MealAppraiseForm.vue?vue&type=template&id=0d0dcb3a&"
import script from "./MealAppraiseForm.vue?vue&type=script&lang=js&"
export * from "./MealAppraiseForm.vue?vue&type=script&lang=js&"
import style0 from "./MealAppraiseForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports